import styled from 'styled-components';

export const StyledImageTagging = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  height: inherit;

  .image-tagging-helper-text {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    color: ${({ theme: { token } }) => token.colorText};
    line-height: ${({ theme: { token } }) => token.lineHeightLG};
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .image-thumbnale-list {
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    flex-shrink: 0;
    height: 82.25px;

    &::-webkit-scrollbar {
      display: none;
    }

    .image-thumbnale-container {
      .image-thumbnale {
        position: relative;
        height: 60px;
        width: 60px;
        border-radius: 4px;
        padding: 0;
        margin: 0;

        :hover {
          cursor: pointer;
          opacity: 0.8;
        }

        .image-thumbnale {
          border-radius: 4px;
          width: 60px;
          height: 60px;
          object-fit: cover;
          object-position: center;
          border: 2px solid transparent;
          transition: border 0.2s;

          &.image-thumbnale-selected {
            border: 2px solid ${({ theme: { token } }) => token.colorPrimary};
          }

          &.image-thumbnale-error {
            border: 2px solid ${({ theme: { token } }) => token.colorErrorActive};
          }
        }

        .image-tag-checkmark {
          position: absolute;
          top: ${({ theme: { token } }) => token.marginXS}px;
          left: ${({ theme: { token } }) => token.marginXS}px;
          color: ${({ theme: { token } }) => token.colorPrimary};
          background-color: ${({ theme: { token } }) => token.colorBgLayout};
          border-radius: 50%;
          font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
          z-index: 1;
        }
      }

      .image-tagging-desktop-thumbnale-tag {
        width: 60px;
        padding-left: ${({ theme: { token } }) => token.paddingXXS}px;
        margin-top: ${({ theme: { token } }) => token.marginXXS}px;
        color: ${({ theme: { token } }) => token.colorText};
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
        line-height: ${({ theme: { token } }) => token.lineHeight};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .image-error-message-container {
    height: 22px;
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;

    .error-icon {
      color: ${({ theme: { token } }) => token.colorError};
    }

    .error-text {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      line-height: ${({ theme: { token } }) => token.lineHeight};
      font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
      color: ${({ theme: { token } }) => token.colorErrorText};
    }

    &.hidden {
      span {
        display: none;
      }
    }
  }

  .image-info {
    display: flex;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    align-items: center;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;

    .image-info-title {
      font-size: ${({ theme: { token } }) => token.fontSizeLG};
      color: ${({ theme: { token } }) => token.colorText};
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      line-height: ${({ theme: { token } }) => token.lineHeight};
    }

    .image-info-name {
      font-size: ${({ theme: { token } }) => token.fontSize};
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
      line-height: ${({ theme: { token } }) => token.lineHeight};
      flex-grow: 1;
      text-overflow: ellipsis;
      overflow-x: hidden;
      white-space: nowrap;
    }

    .remove-image-btn {
      padding: 0;
      height: 24px;
      width: 24px;
      color: ${({ theme: { token } }) => token.colorText};
    }
  }

  .image-carousel {
    width: 240px;

    .ant-image-img {
      width: 240px;
      height: 240px;
      object-fit: cover;
      object-position: center;
    }
  }

  .image-tag-list-container {
    margin: ${({ theme: { token } }) => token.marginXS}px 0;

    .image-tag-list {
      display: flex;
      flex-wrap: wrap;
      gap: ${({ theme: { token } }) => token.marginSM}px;

      .image-tag {
        margin: 0;
        border-radius: 4.8px;
        padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
        line-height: ${({ theme: { token } }) => token.lineHeightLG};
        font-size: ${({ theme: { token } }) => token.imageTagFontSizeSM}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
        border: 1.2px solid ${({ theme: { token } }) => token.colorPrimaryBorderHover};
        background: ${({ theme: { token } }) => token.colorBgContainer};
        color: ${({ theme: { token } }) => token.colorPrimary};
      }

      .ant-tag-checkable-checked {
        background: ${({ theme: { token } }) => token.colorPrimary};
        color: ${({ theme: { token } }) => token.solidTextColor};
      }
    }
  }

  .image-tagging-footer {
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
    display: flex;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    justify-content: flex-end;
  }

  &.image-tagging-container-mobile {
    .image-thumbnale-list {
      height: 60px;
    }

    .image-error-message-container {
      &.image-error-message-container {
        margin-top: ${({ theme: { token } }) => token.marginXS}px;
        transition: height 0.5s, margin-top 0.5s;

        &.hidden {
          height: 0;
          margin-top: 0;
        }
      }
    }

    .image-carousel {
      width: 100%;

      .ant-image-img {
        width: 100%;
        height: 400px;
        object-fit: contain;
      }
    }

    .image-tag-list-container {
      flex-grow: 1;

      .image-tag {
        font-size: ${({ theme: { token } }) => token.imageTagFontSize}px;
        padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingSM}px;
        height: 40px;
      }
    }

    .image-tagging-footer {
      flex-direction: column;
      padding-inline: ${({ theme: { token } }) => token.paddingXS}px;
      gap: ${({ theme: { token } }) => token.marginLG}px;

      .mobile-image-select-upload {
        width: 100%;

        .ant-upload {
          width: inherit;
        }
      }

      .image-upload-btn {
        width: 100%;
        font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
        line-height: ${({ theme: { token } }) => token.lineHeightLG};
        height: 40px;

        &.image-upload-finish {
          order: -1;
        }
      }
    }
  }
`;
